module.exports = __webpack_public_path__ + "static/media/yelpcamp4.9f9b8bca.jpg";